import { appState } from '../js/state.js';

// Debugging confirmation
console.log('✅ DashboardUser Master Page Builder loaded successfully!');

import '../js/loader-styles-heavy.js';

// 1) Build-and-cache the *static* master HTML (header+footer) exactly once:
let _staticMasterPromise = null;
let _staticMasterListenerToReAttach = [];
let _staticMasterLang = null; // Track the last language used

// DashboardUser Master Page Builder
export async function buildMasterLayoutDashboardUser() {
  console.log(`🔄 User Dashboard Master Page Builder - Starting to build auth master page`);

  try {
      if (_staticMasterPromise && _staticMasterLang === appState.SiteLanguageCookie) {
      // 1) Dynamically import the layout utility
      const { registerEventListenerToAttach } = await import(
        /* webpackChunkName: "to-attach-event-listener-registry", webpackPrefetch: true  */
        '../js/to-attach-event-listener-registry.js'
      );

      // re-attach every one of your listeners:
      _staticMasterListenerToReAttach.forEach(initFn => registerEventListenerToAttach(initFn));

      return await _staticMasterPromise;
    }

    // 1) Dynamically import the layout utility
    const { getMasterLayoutContentByFolderPath } = await import(
      /* webpackChunkName: "build-manager-utils", webpackPrefetch: true  */
      '../js/build-manager-utils.js'
    );

    const masterLayoutTemplate = await getMasterLayoutContentByFolderPath(
      'layouts/master-layout-dashboard-user'
    );

    // 3) Dynamically import all header/footer components in parallel
    const [
      { buildComponentPreHeader, initComponentPreHeader },
      { buildComponentHeaderLinksShop, initComponentHeaderLinksShop },
      { buildComponentSelectLanguageTop, initComponentSelectLanguageTop },
      { buildComponentShipToCountryTop, initComponentShipToCountryTop },
      { buildComponentSelectCurrencyTop, initComponentSelectCurrencyTop },
      { buildComponentLoginUserOptionsTop, initComponentLoginUserOptionsTop },
      { buildComponentHeaderShop, initComponentHeaderShop },
      { buildComponentScrollToTop, initbuildComponentScrollToTop },
      { buildComponentNotAuthorizedLoginRedirect, initbuildComponentNotAuthorizedLoginRedirect },
      { buildComponentAccountSidebar, initComponentAccountSidebar },
    ] = await Promise.all([
      import(
        /* webpackChunkName: "pre-header", webpackPrefetch: true  */ '../builders-components/header/pre-header.js'
      ),
      import(
        /* webpackChunkName: "header-links-shop", webpackPrefetch: true  */ '../builders-components/header/header-links-shop.js'
      ),
      import(
        /* webpackChunkName: "select-language-top", webpackPrefetch: true  */ '../builders-components/header/select-language-top.js'
      ),
      import(
        /* webpackChunkName: "ship-to-country-top", webpackPrefetch: true  */ '../builders-components/header/ship-to-country-top.js'
      ),
      import(
        /* webpackChunkName: "select-currency-top", webpackPrefetch: true  */ '../builders-components/header/select-currency-top.js'
      ),
      import(
        /* webpackChunkName: "login-user-options-top", webpackPrefetch: true  */ '../builders-components/header/login-user-options-top.js'
      ),
      import(
        /* webpackChunkName: "header-shop", webpackPrefetch: true  */ '../builders-components/header/header-shop.js'
      ),
      import(
        /* webpackChunkName: "scroll-to-top-button", webpackPrefetch: true  */ '../builders-components/scroll-to-top-button/scroll-to-top-button.js'
        ),
        import(
            /* webpackChunkName: "not-authorized-login-redirect", webpackPrefetch: true  */ '../builders-components/not-authorized-login-redirect/not-authorized-login-redirect.js'
        ),

      import(
        /* webpackChunkName: "account-sidebar" */ '../builders-components/account/components/shared-business-and-personal/account-sidebar.js'
      ),
    ]);

    // 4) Build all components in parallel
    const [
      preHeaderContent,
      headerLinksContent,
      selectLanguageContent,
      shipToCountryContent,
      selectCurrencyContent,
      loginUserOptionsContent,
      headerContent,
        scrollToTopContent,
        notAuthorizedLoginRedirectContent,
      sidebar,
    ] = await Promise.all([
      buildComponentPreHeader(),
      buildComponentHeaderLinksShop(),
      buildComponentSelectLanguageTop(),
      buildComponentShipToCountryTop(),
      buildComponentSelectCurrencyTop(),
      buildComponentLoginUserOptionsTop(),
      buildComponentHeaderShop(),
        buildComponentScrollToTop(),
       buildComponentNotAuthorizedLoginRedirect(),
      buildComponentAccountSidebar(),
    ]);

    const newContent = `<center>

    <div class="myPageMargins">



    <div class="grid-like-table-one-row-two-cells-layout-dashboard-t-and-c">
            <div class="grid-like-table-one-row-two-cells-layout-dashboard-t-and-c-cell-A">

             
                ${sidebar}

              </div>
            <div class="grid-like-table-one-row-two-cells-layout-dashboard-t-and-c-cell-B">
            <center>

           {{{ content }}}

           </center>
     
              </div>
     </div>
        </div>

        <div class="safe-footer"></div>

        </center>
`;

    // 5) Assemble header-links with nested placeholders
    const assembledHeaderLinks = headerLinksContent
      .replace('{{{ select-language-top }}}', selectLanguageContent)
      .replace('{{{ ship-to-country-top }}}', shipToCountryContent)
      .replace('{{{ select-currency-top }}}', selectCurrencyContent)
      .replace('{{{ login-user-options-top }}}', loginUserOptionsContent);

    // 6) Merge all parts into the master layout
    //const result = masterLayoutTemplate
    //  .replace('{{{ pre-header }}}', preHeaderContent)
    //  .replace('{{{ header }}}', headerContent)
    //  .replace('{{{ header-links }}}', assembledHeaderLinks)
    //  .replace('{{{ scroll-to-top }}}', scrollToTopContent)
    //      .replace('{{{ content }}}', newContent);

      const result = `

           ${notAuthorizedLoginRedirectContent}

      ${preHeaderContent}


       ${assembledHeaderLinks}

         ${headerContent}

        
        
         ${newContent}

          ${scrollToTopContent}

       


      `;



    // Cache the static master layout promise
    _staticMasterPromise = Promise.resolve(result);
      _staticMasterLang = appState.SiteLanguageCookie; 


    // add event listener to reattch
      _staticMasterListenerToReAttach = [
          initbuildComponentNotAuthorizedLoginRedirect, // putting this first so it gets executed first
      initComponentPreHeader,
      initComponentHeaderLinksShop,
      initComponentSelectLanguageTop,
      initComponentShipToCountryTop,
      initComponentSelectCurrencyTop,
      initComponentLoginUserOptionsTop,
      initComponentHeaderShop,
        initbuildComponentScrollToTop,
        
      initComponentAccountSidebar,
    ];

    return result;
  } catch (error) {
    console.error('❌ Error building User Dashboard  master page content:', error);
    return 'Error loading User Dashboard  master page content.';
  }
}
